import { render, staticRenderFns } from "./structured.vue?vue&type=template&id=507efd79"
import script from "./structured.vue?vue&type=script&lang=js"
export * from "./structured.vue?vue&type=script&lang=js"
import style0 from "./structured.vue?vue&type=style&index=0&id=507efd79&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports